module.exports = __webpack_public_path__ + "img/ZainBrand.05e2ff0f.svg";